import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Clock } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AtorDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sessoesEspera, setSessoesEspera] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const sessoesRes = await axios.get(`${API}/admin/sessoes/espera`);
      setSessoesEspera(sessoesRes.data);
    } catch (error) {
      toast.error('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#191919]">
        <div className="text-white text-xl">Carregando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#191919] text-white">
      <div className="border-b border-gray-800">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">Painel do Ator</h1>
            <p className="text-gray-400 text-sm mt-1">Bem-vindo, {user?.nome}</p>
          </div>
          <Button
            onClick={handleLogout}
            variant="outline"
            className="border-[#CF0D1D] text-[#CF0D1D] hover:bg-[#CF0D1D] hover:text-white"
            data-testid="ator-logout-button"
          >
            Sair
          </Button>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold mb-2">Estações Disponíveis</h2>
          <p className="text-gray-400">Selecione uma sessão para interpretar</p>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {/* Card Sessões em Espera */}
          <Card
            className="bg-white border-gray-200 cursor-pointer hover:scale-105 transition-transform hover:shadow-xl"
            onClick={() => navigate('/ator/sessoes/espera')}
            data-testid="sessoes-espera-card"
          >
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#CF0D1D]/10 rounded-full flex items-center justify-center">
                  <Clock className="w-6 h-6 text-[#CF0D1D]" />
                </div>
                <div>
                  <CardTitle className="text-[#191919] text-xl">Estações em Espera</CardTitle>
                  <CardDescription className="text-gray-600">
                    {sessoesEspera.length} {sessoesEspera.length === 1 ? 'sessão' : 'sessões'} aguardando
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 text-sm">
                Visualize e entre em sessões que estão aguardando um ator
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AtorDashboard;